var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMonthlyPayOrderServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 41.9287,
    width: 74.6421,
    height: 15.7141,
    rx: 7.85706,
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.63867,
    y: 51.8105,
    width: 73.4591,
    height: 21.9584,
    rx: 10.9792,
    transform: "rotate(-35 3.63867 51.8105)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 57.6436,
    width: 86.4277,
    height: 15.7141,
    rx: 7.85706,
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 73.3564,
    width: 78.5706,
    height: 15.7141,
    rx: 7.85706,
    fill: "#EEC2B9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 89.0713,
    width: 70.7136,
    height: 15.7141,
    rx: 7.85706,
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9263,
    cy: 71.3945,
    rx: 31.4283,
    ry: 33.3925,
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 37.4697,
    width: 74.6416,
    height: 15.714,
    rx: 7.85701,
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.64258,
    y: 47.3467,
    width: 73.4585,
    height: 21.9583,
    rx: 10.9791,
    transform: "rotate(-35 3.64258 47.3467)",
    fill: "#FFDCD5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 53.1826,
    width: 86.4271,
    height: 15.714,
    rx: 7.85701,
    fill: "#FFDCD5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 68.8975,
    width: 78.5701,
    height: 15.714,
    rx: 7.85701,
    fill: "#FFDCD5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0703,
    y: 84.6104,
    width: 70.7131,
    height: 15.714,
    rx: 7.85701,
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9261,
    cy: 66.9333,
    rx: 31.428,
    ry: 33.3923,
    fill: "#FFDCD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6719 79.1483C39.86 79.1483 53.0426 67.1574 55.0486 45.3271C60.9434 54.6817 60.9434 74.59 56.4074 93.2382",
    stroke: "#EEC2B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonthlyPayOrderServiceMain);
export default __webpack_public_path__ + "static/media/IcMonthlyPayOrderServiceMain.80a35462f43acc8ab4293a5747ecad89.svg";
export { ForwardRef as ReactComponent };